<template>
  <div class="card card-button">
    <div class="card-body">
      <div class="button-icon-left">
        <p v-if="!status" class="float-right unable-status">
          {{ $t("unavailable") }}
        </p>
        <div v-if="icon === 'take_away'" class="icon-order">

          <span class="svg-icon svg-icon-info svg-icon-2hx"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
              <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect x="0" y="0" width="24" height="24"/>
                  <path d="M5.94290508,4 L18.0570949,4 C18.5865712,4 19.0242774,4.41271535 19.0553693,4.94127798 L19.8754445,18.882556 C19.940307,19.9852194 19.0990032,20.9316862 17.9963398,20.9965487 C17.957234,20.9988491 17.9180691,21 17.8788957,21 L6.12110428,21 C5.01653478,21 4.12110428,20.1045695 4.12110428,19 C4.12110428,18.9608266 4.12225519,18.9216617 4.12455553,18.882556 L4.94463071,4.94127798 C4.97572263,4.41271535 5.41342877,4 5.94290508,4 Z" fill="#000000" opacity="0.3"/>
                  <path d="M7,7 L9,7 C9,8.65685425 10.3431458,10 12,10 C13.6568542,10 15,8.65685425 15,7 L17,7 C17,9.76142375 14.7614237,12 12,12 C9.23857625,12 7,9.76142375 7,7 Z" fill="#000000"/>
              </g>
          </svg></span>
          <!-- <img src="@/assets/take_away.png" class="icon-order" alt="" /> -->
          
        </div>
        <div v-if="icon === 'walkin'">
          <span class="svg-icon svg-icon-info svg-icon-2hx"><svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                <path d="M3.98842709,3.05999994 L11.0594949,10.1310678 L8.23106778,12.9594949 L3.98842709,8.71685419 C2.42632992,7.15475703 2.42632992,4.62209711 3.98842709,3.05999994 Z" fill="#000000"/>
                <path d="M17.7539614,3.90710683 L14.8885998,7.40921548 C14.7088587,7.62889898 14.7248259,7.94903916 14.9255342,8.14974752 C15.1262426,8.35045587 15.4463828,8.36642306 15.6660663,8.18668201 L19.1681749,5.32132039 L19.8752817,6.02842717 L17.0099201,9.53053582 C16.830179,9.75021933 16.8461462,10.0703595 17.0468546,10.2710679 C17.2475629,10.4717762 17.5677031,10.4877434 17.7873866,10.3080024 L21.2894953,7.44264073 L21.9966021,8.14974752 L18.8146215,11.331728 C17.4477865,12.6985631 15.2317091,12.6985631 13.8648741,11.331728 C12.4980391,9.96489301 12.4980391,7.74881558 13.8648741,6.38198056 L17.0468546,3.20000005 L17.7539614,3.90710683 Z" fill="#000000"/>
                <path d="M11.0753788,13.9246212 C11.4715437,14.3207861 11.4876245,14.9579589 11.1119478,15.3736034 L6.14184561,20.8724683 C5.61370242,21.4567999 4.71186338,21.5023497 4.12753173,20.9742065 C4.10973311,20.9581194 4.09234327,20.9415857 4.0753788,20.9246212 C3.51843234,20.3676747 3.51843234,19.4646861 4.0753788,18.9077397 C4.09234327,18.8907752 4.10973311,18.8742415 4.12753173,18.8581544 L9.62639662,13.8880522 C10.0420411,13.5123755 10.6792139,13.5284563 11.0753788,13.9246212 Z" fill="#000000" opacity="0.3"/>
                <path d="M13.0754022,13.9246212 C13.4715671,13.5284563 14.1087399,13.5123755 14.5243844,13.8880522 L20.0232493,18.8581544 C20.0410479,18.8742415 20.0584377,18.8907752 20.0754022,18.9077397 C20.6323487,19.4646861 20.6323487,20.3676747 20.0754022,20.9246212 C20.0584377,20.9415857 20.0410479,20.9581194 20.0232493,20.9742065 C19.4389176,21.5023497 18.5370786,21.4567999 18.0089354,20.8724683 L13.0388332,15.3736034 C12.6631565,14.9579589 12.6792373,14.3207861 13.0754022,13.9246212 Z" fill="#000000" opacity="0.3"/>
        </svg></span>
          <!-- <img src="@/assets/walkin.png" class="icon-order" alt="" /> -->
        </div>
        <div v-if="icon === 'staying'">
          
          <span class="svg-icon svg-icon-info svg-icon-2hx"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path d="M17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6Z" fill="#121319"/>
<path opacity="0.25" fill-rule="evenodd" clip-rule="evenodd" d="M18.818 14.1248C18.2016 13.4101 17.1428 13.4469 16.3149 13.9001C15.0338 14.6013 13.5635 15 12 15C10.4365 15 8.96618 14.6013 7.68505 13.9001C6.85717 13.4469 5.79841 13.4101 5.182 14.1248C3.82222 15.7014 3 17.7547 3 20V21C3 22.1045 3.89543 23 5 23H19C20.1046 23 21 22.1045 21 21V20C21 17.7547 20.1778 15.7014 18.818 14.1248Z" fill="#191213"/>
</svg></span>
          <!-- <img src="@/assets/staying.png" class="icon-order" alt="" /> -->
        </div>
        <div v-if="icon === 'delivery'">
          <span class="svg-icon svg-icon-info svg-icon-2hx"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<path opacity="0.25" d="M13 5H2C0.895431 5 0 5.89543 0 7V15C0 16.1046 0.895431 17 2 17H3H7H14.5C14.7761 17 15 16.7761 15 16.5V7.00057C15 5.896 14.1046 5 13 5Z" fill="#12131A"/>
<path d="M15.5 8C15.2239 8 15 8.22386 15 8.5V16.5C15 16.7761 15.2239 17 15.5 17H18H21H23C23.5523 17 24 16.5523 24 16V12.6637C24 12.0249 23.6948 11.4244 23.1786 11.0479L19.5267 8.38417C19.1844 8.13452 18.7717 8 18.3481 8H15.5Z" fill="#12131A"/>
<path d="M5 19C6.10457 19 7 18.1046 7 17C7 15.8954 6.10457 15 5 15C3.89543 15 3 15.8954 3 17C3 18.1046 3.89543 19 5 19Z" fill="#12131A"/>
<path d="M19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15C17.8954 15 17 15.8954 17 17C17 18.1046 17.8954 19 19 19Z" fill="#12131A"/>
</svg></span>
          <!-- <img src="@/assets/delivery.png" class="icon-order" alt="" /> -->
        </div>
      </div>

      <h5 class="card-title">{{ title }}</h5>
      <p class="card-text">
        {{ memo }}
      </p>
    </div>
  </div>
</template>
<style lang="scss">
.icon-order {
  max-width: 40px;
}
.unable-status {
  margin-top: -21px;
  background: #b81303;
  color: white;
  padding: 4px;
  margin-right: -20px;
  margin-bottom: 10px;
}
.svg-icon svg{
  fill: white;
}

.svg-icon.svg-icon-info svg [fill]:not(.permanent):not(g) {
  transition: fill 0.3s ease;
  fill: #F5F8FA;
}

.svg-icon.svg-icon-2hx svg {
    height: 40px !important;
    width: 40px !important;
    fill: white;
}
</style>
<script>
export default {
  name: "btnOpenOrder",

  props: {
    title: { type: String, default: null },
    memo: { type: String, default: null },
    icon: { type: String, default: "" },
    status: { type: Boolean, default: false },
  },
};
</script>

